import { createContext, useContext } from "react";

import type { OnlineOrder, Order } from "~/providers/order-provider";

interface OrderContext {
  orders: Order[];
  onlineOrders: OnlineOrder[];
  isFetchingOrders: boolean;
}

export const OrderContext = createContext<OrderContext | undefined>(undefined);

export const useOrder = () => {
  const context = useContext(OrderContext);
  if (context === undefined) {
    throw new Error("useOrder must be used within a OrderProvider");
  }
  return context;
};
